import { ChangeDetectorRef, Input, Optional, Self, ElementRef, EventEmitter, HostListener, HostBinding, AfterViewInit, Directive } from '@angular/core';
import { ControlValueAccessor, NgControl, NgModel } from '@angular/forms';

@Directive()
export class PickerAbstract implements ControlValueAccessor, AfterViewInit {
    public readonly valueChange: EventEmitter<Date | null>;

    public pickerSelector: string;
    public picker: any;

    @Input() ngModel: NgModel;

    private innerDateValue: Date;
    @HostBinding('value') public outerValue: string;

    constructor(private _element: ElementRef,
                private changeRef: ChangeDetectorRef,
                @Optional() @Self() private ngControl?: NgControl
    ) {
        this.valueChange = new EventEmitter<Date | null>();

        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }

    public ngAfterViewInit() {
        this.picker = this._element.nativeElement.querySelector(this.pickerSelector);

        if (this.picker) {
            this.picker.setInputValue(this.innerDateValue);
            this.outerValue = this._element.nativeElement.value;
        }
    }

    // // Start: ControlValueAccessor requirement
    public writeValue(newValue: Date): void {
        if (this.picker && this.innerDateValue !== newValue) {
            this.picker.setInputValue(newValue);
            this.outerValue = this._element.nativeElement.value;
        }

        this.innerDateValue = newValue;
    }

    public onChange: (value: any) => void = () => {/**/};
    public onTouch: () => void = () => {/**/};

    public registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }
    // // End: ControlValueAccessor requirements

    public changeHandler(changedVal: {inner: Date, outer: string, refreshOuter: boolean}): void {
        if (changedVal.refreshOuter) {
            this.outerValue = changedVal.outer;
        }

        this.innerDateValue = changedVal.inner;

        this.propogateInnerValueChange();
        this.changeRef.markForCheck();

        // Handle for keyup
        if (changedVal.inner) {
            this.onTouch();
        }
    }

    private propogateInnerValueChange(): void {
        if (this.ngControl) {
            this.ngControl.control.setValue(this.innerDateValue);
        }
        this.valueChange.emit(this.innerDateValue);
    }
}
